import { serverIP } from "./const";

const config = {
  //   baseUrl: `http://${serverIP}:7575/v1/admin/`,
  baseUrl: `https://${serverIP}/v1/admin/`,
};
export default config;
